module.exports = __webpack_public_path__ + "img/ptz-icon3.f9c2b34d.svg";